import React, { useState } from 'react';
import { useCart } from './CartContext';
import {useTranslation} from "react-i18next";
import logo from "../../assets/images/mariposaEB_logo_no_background.png";


const AddToCart = ({ product }: {
    collectionKey: string;
    product: { id: number; imageUrl: string | null; name: string; price: number }
}) => {
    const { addToCart } = useCart();
    const [added, setAdded] = useState(false);
    const {t} = useTranslation()

    const handleClick = () => {
        addToCart({
            id: product.id,
            name: product.name,
            price: `${product.price} €`,
            imageUrl: product.imageUrl ? product.imageUrl : logo,
        });
        setAdded(true);
        setTimeout(() => setAdded(false), 1500);
    };

    return (
        <button className={`btn-add-to-cart ${added ? 'added' : ''}`} onClick={handleClick}>
            {added ? t("cart.added") : t("cart.add-to-cart") }
        </button>
    );
};

export default AddToCart;
